import React from 'react';
import styled from 'styled-components';
import riseIconSrc from '../../../assets/icons/rise.svg';
import { useSelector } from 'react-redux';
import decreaseIconSrc from '../../../assets/icons/decrease.svg';
import { getClubValue } from '../licenseAnalyticsSupport/getLicenseAnalyticsActions';
import { useTranslation } from 'react-i18next';

const Label = styled.div`
  inline-size: 150px;
  overflow-wrap: break-word;
  font-family: Montserrat;
  font-weight: bold;
  font-size: 14px;
`;

export interface MetricsProps {
  title?: string;
  spendValue?: number | string;
  metricsValue?: number;
  customStyles?: any;
  showYen?: boolean;
  noClubLabel?: boolean;
  showYOY?: boolean;
}

const LicenseMetrics: React.FC<MetricsProps> = ({
  title,
  spendValue,
  metricsValue,
  customStyles,
  showYen,
  noClubLabel,
  showYOY,
}) => {
  const rating = useSelector((state: any) => state.rating);
  const club = useSelector(getClubValue);
  const [t] = useTranslation();

  return (
    <>
      <Label>
        {title} {rating}
      </Label>
      <div className="spendingWrapper">
        <div style={{ display: 'flex', flexDirection: 'column', marginTop: 25 }}>
          {showYOY && metricsValue ? (
            <>
              <img src={+metricsValue > 0 ? riseIconSrc : decreaseIconSrc} alt="" className="growthImg" />
              <h6 style={{ color: metricsValue > 0 ? '#50C878' : '#FF5733' }}>
                {+metricsValue == 0 ? '' : +metricsValue > 0 ? '+' : ''}
                {metricsValue.toFixed(1)}% YOY
              </h6>
            </>
          ) : (
            <></>
          )}
        </div>
        <h2 style={customStyles} className="spendValue">
          {(showYen ? '¥ ' : '') + spendValue}
        </h2>
      </div>
    </>
  );
};

export default React.memo(LicenseMetrics);
